import api from "./api";

async function getSalesOrders() {
  try {
    const response = await api.get("api/salesorders", { bypassInterceptor: true });
    return response.data;
  } catch (error) {
    return [];
  }
}


export { getSalesOrders };